import { Proveedor } from '../../proveedor/proveedor';

export class Compra {

    documento?:string;
    serie?:string;
    numero?:string;
    serdoc?:string;
    numdoc?:string;
    idprovee?:string;
    fecemi?:string;
    fectra?:string;
    fecven?:string;
    feccan?:string;
    estado?:string;
    valorcom?:number;
    total?:number;
    igv?:number;
    tcambio?:number;
    moneda?:string;
    idsucursal?:string;
    pago?:string;
    impbruto?:number;
    impren?:number;
    impes?:number;
    impneto?:number;
    mercad?:string;
    diasletras?:string
    referencia?:string;
    transporte?:string;
    transruc?:string;
    fletefec?:string;
    fletedoc?:string;
    fletenum?:string;
    fechaest?:string;
    documest?:string;
    motivo?:string;
    reffecha?:string;
    idorden?:string;
    ordser?:string;
    ordnum?:string;
    afectoigv?:string;
    documeng?:string;
    serieg?:string;
    numerog?:string;
    observa?:string;
    trp_valvta?:number;
    trp_igv?:number;
    fleteser?:string;
    peso_total?:number;
    costo_kilo?:number;
    tipo_ope?:string;
    fvcto?:string;
    pedido_ser?:string;
    pedido_num?:string;
    mon_flete?:string;
    cambioflet?:number;
    idcompra?:string;
    ncrdoc?:string;
    ncrser?:string;
    ncrnum?:string;
    ncrfecha?:string;
    ncrvalvta?:number;
    ncrigvt?:number;
    ncrtotal?:number;
    personalc_id?:string;
    personalm_id?:string;
    dtmodificacion?:string;
    percepcion?:number;
    tasapercepcion?:number;
    totalper?:number;
    fec_depos?:string;
    ciu_depos?:string;
    tarjeta?:string;
    voucher?:string;
    tarjetachq?:number;
    banco?:string;
    cod_banco?:string;
    porrenta?:number;
    apagar?:number;
    renta?:number;
    nogravado?:number;
    proveedor?:Proveedor;
    constructor(){
        this.proveedor = new Proveedor();
    }
}
